
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Gauge } from 'lucide-react';

// Maintenance tab content
export const MaintenanceTab = () => (
  <div className="p-4 space-y-6">
    <div className="flex items-center gap-2 mb-4">
      <Gauge className="text-blue-500 h-5 w-5" />
      <h3 className="text-lg font-medium">Maintenance Status</h3>
    </div>
    
    <Card>
      <CardContent className="p-4">
        <div className="space-y-4">
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-800 pb-3">
            <div>
              <p className="font-medium">Filter Replacement</p>
              <p className="text-sm text-gray-500">Last changed: 45 days ago</p>
            </div>
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
              Good (75%)
            </Badge>
          </div>
          
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-800 pb-3">
            <div>
              <p className="font-medium">Coil Cleaning</p>
              <p className="text-sm text-gray-500">Last cleaned: 92 days ago</p>
            </div>
            <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
              Due Soon
            </Badge>
          </div>
          
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-800 pb-3">
            <div>
              <p className="font-medium">Refrigerant Level</p>
              <p className="text-sm text-gray-500">Last checked: 120 days ago</p>
            </div>
            <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
              Check Required
            </Badge>
          </div>
          
          <div className="flex items-center justify-between pb-3">
            <div>
              <p className="font-medium">Belt Tension</p>
              <p className="text-sm text-gray-500">Last adjusted: 30 days ago</p>
            </div>
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
              Good
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
    
    <p className="text-sm text-gray-500">
      Regular maintenance helps maintain system efficiency and extends equipment life.
    </p>
  </div>
);
